import {service} from '../common/request.js';
 
export function getCourseDetail(data) {
  return service({
		url: '/app/phase-student/getPhaseStudentById',
		method: 'GET',
		data
	})
}

export function getLessonDetail(data) {
	return service({
		url: '/app/resource/getResourceByPeriod',
		method: 'GET',
		data
	})
}

export function postNewStudy(data) {
	return service({
		url: '/app/student-study',
		method: 'POST',
		data
	})
}

export function postUpdateStudy(data) {
	return service({
		url: '/app/student-study/progress',
		method: 'POST',
		data
	})
}